import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Helmet from 'react-helmet';
import _ from 'lodash';

import {
  RunwaySection,
  RunwayTitle,
  RunwayWrapper,
  RunwayContentWrapper,
  RunwayImageWrapper,
  RunwayImage,
  RunwayDescription,
  RunwayLinkWrapper
} from '@/pages/EditorialPage/EditorialPage.style';
import { getScreenWidth, generateKey, makeCanonicalTagObj, makeHreflangTagArr } from '@/utils';
import EditorialHero from './EditorialHero/EditorialHero';
import ProductRecommendation from '../../components/ProductRecommendation/ProductRecommendation';
import BreadCrumbMenu from '../../components/BreadCrumbMenus/';
import Placeholder from '../../components/Placeholder';
import { TABLET_L } from '../../constants';

import Quote from './Quote/Quote';
import StylesGallery from './StylesGallery/StylesGallery';
import StylistsOverview from './StylistsOverview';
import Trend from './Trend/Trend';
import VideoSection from './VideoSection';
import PastArticles from './PastArticles/PastArticles';


const btcSlug = 'beauty-creators-talk';
const caSlug = 'creators-academy';

/**
 *「クリエーション」画面 > 各シーズンページ
 */
const EditorialPage = ({ copy, data, locale, menuInfo, screenSize }) => (
  <React.Fragment>
    {_.get(data, 'slug') && (
      <Helmet
        link={[makeCanonicalTagObj(locale, `/inspiration/${data.slug}`), ...makeHreflangTagArr(data.region, `/inspiration/${data.slug}`)]}
      />
    )}
    {_.get(data, 'metaData') && (
      <Helmet
        title={_.get(data.metaData, 'title')}
        meta={[
          {
            name: 'description',
            content: _.get(data.metaData, 'description'),
          },
          {
            name: 'keyword',
            content: _.get(data.metaData, 'keyword'),
          },
          // TODO: OGP タグは一旦保留 (2020年01月07日)
          // {
          //   property: 'og:url',
          //   content: _.get(data.metaData, 'url'),
          // },
          // {
          //   property: 'og:type',
          //   content: _.get(data.metaData, 'type'),
          // },
          // {
          //   property: 'og:title',
          //   content: _.get(data.metaData, 'title'),
          // },
          // {
          //   property: 'og:image',
          //   content: _.get(data.metaData, 'image.file.url'),
          // },
          // {
          //   property: 'og:description',
          //   content: _.get(data.metaData, 'description'),
          // },
          // {
          //   property: 'og:site_name',
          //   content: _.get(data.metaData, 'siteName'),
          // },
        ]}
      />
    )}
    {/* 最上部に表示されるアピール部分 (西暦、タイトル、画像が縦並びで表示される) */}
    <EditorialHero data={data} />

    {/* VIDEO (コンテンツがない場合はトリツメ) */}
    {data.heroVideo && <VideoSection video={data.heroVideo}/>}

    {/* COLLECTION */}
    {!!(data.slug && data.styles) && (
      <StylesGallery
        copy={copy}
        styles={data.styles}
        season={data.season}
        locale={locale}
        prevSlug={data.slug}
        ancestor={data.title.toUpperCase()}
      />
    )}

    {/* TRENDS */}
    {data.trends &&
    data.trends.map((trend, index) => (
      <Trend
        key={trend.entryId}
        parentSlug={data.slug}
        locale={locale}
        trend={trend}
        index={index}
        isLast={index === data.trends.length - 1}
        title={trend.title}
        sectionTitle={trend.sectionTitle}
        isTitleBottom={trend.isTitleBottom}
        screenSize={screenSize}
      />
    ))}

    {/* RUNWAY (コンテンツがない場合はトリツメ) */}
    {!!(_.get(data, 'contents') && data.contents[0]) && (
      <RunwaySection>
        <RunwayTitle>
          {data.contents[0].title || <Placeholder w="100%" h="100px" />}
        </RunwayTitle>
        {!_.get(data, 'slug') && !_.get(data.contents[0], 'contentsList') ? (
          <Placeholder w="100%" h="100px" />
        ) : (
          <RunwayWrapper>
            {data.contents[0].contentsList.map(({ description, image, label, inspirationArticle }, index) => (
              <RunwayContentWrapper key={generateKey('runway', index)} width={window.innerWidth > TABLET_L ? '225px' : '100%'} paddingRight={window.innerWidth > TABLET_L ? '20px' : '0'}>
                <RunwayImageWrapper dimension={window.innerWidth > TABLET_L ? '225px' : `${window.innerWidth - 40}px`}>
                  {!_.get(image, 'file.url') ? (
                    <Placeholder w="100%" h="100px" />
                  ) : (
                    <RunwayImage srcImage={image.file.url} />
                  )}
                </RunwayImageWrapper>
                <RunwayDescription>{description}</RunwayDescription>
                <RunwayLinkWrapper>
                  <Link to={`/${locale}/inspiration/${data.slug}/${inspirationArticle.slug}`} href={`/${locale}/inspiration/${data.slug}/${inspirationArticle.slug}`}>
                    {label}
                  </Link>
                </RunwayLinkWrapper>
              </RunwayContentWrapper>
            ))}
          </RunwayWrapper>
        )}
      </RunwaySection>
    )}

    {/* BEAUTY CREATORS */}
    {data.stylists && <StylistsOverview title={copy.creators} stylists={data.stylists}/>}

    {data.secondaryVideo && <VideoSection title={copy.behind_the_scene} video={data.secondaryVideo}/>}

    {data.quote && <Quote quote={data.quote}/>}

    {data.relatedProducts && (
      <ProductRecommendation relatedProducts={data.relatedProducts} locale={locale} copy={copy}/>
    )}

    {/* {data.pastArchives = {}} */}

    {(data.slug === btcSlug || data.slug === caSlug) && (
      <PastArticles screenSize={screenSize} isBTC={data.slug === btcSlug} copy={copy}/>
    )}

    {!(locale && data && _.get(data, 'title') && _.get(data, 'slug') && menuInfo && _.get(menuInfo, 'label')) ? (
      <Placeholder w="200px" h="24px" m={window.innerWidth > TABLET_L ? '0 0 20px 40px' : '0 0 20px 20px'} />
    ) : (
      <BreadCrumbMenu
        gray={data.slug === btcSlug || data.slug === caSlug}
        currentPath={`https://www.shiseido-professional.com/${locale}/inspiration/${data.slug}`}
        items={[
          {
            name: 'TOP',
            path: `/${locale}/`,
          },
          {
            name: menuInfo.label,
            path: `/${locale}/inspiration/`,
          },
          {
            name: data.title.toUpperCase(),
            path: null,
          },
        ]}
      />
    )}
  </React.Fragment>
);

EditorialPage.defaultProps = {
  copy: {},
  data: {
    stylists: [{ key: 1 }, { key: 2 }, { key: 3 }, { key: 4 }],
    notLoaded: true,
    relatedProducts: [],
    styles: [],
  },
  screenSize: null,
};

EditorialPage.propTypes = {
  // INSPIRATION (クリエイション) メニュー情報 (パンくずリストに必要な情報を含む)
  menuInfo: PropTypes.shape({}).isRequired,
  copy: PropTypes.shape(),
  data: PropTypes.shape({
    relatedProducts: PropTypes.arrayOf(PropTypes.shape()),
    styles: PropTypes.arrayOf(PropTypes.shape()),
  }),
  locale: PropTypes.string.isRequired,
  // スクリーンサイズ
  screenSize: PropTypes.number,
};

const mapState = state => ({
  // INSPIRATION (クリエイション) メニュー情報をキャッシュしておく
  menuInfo: state.siteOptions.menu ? state.siteOptions.menu[1] : {},
  copy: state.siteOptions.siteCopyEditorialPage,
  locale: state.locale,
  // スクリーンサイズを実寸で取得する
  screenSize: getScreenWidth(),
});

export default connect(mapState)(EditorialPage);



// WEBPACK FOOTER //
// ./src/pages/EditorialPage/EditorialPage.js